import React, { useRef, useEffect, useState } from 'react'
import styled from 'styled-components'
import PortableText from '@sanity/block-content-to-react'

const media = {
  medium: '@media(min-width:700px)',
  large: '@media(min-width:1200px)',
  xLarge: '@media(min-width:1800px)'
}

const FacultyLetter = styled.div`
  font-weight:100;
  color:var(--white);
  margin-top:20vh;
  display:grid;
  

  p{
    font-size:var(--medium-text);
    ${media.medium}{
      font-size:var(--large-text);

    }
    ${media.large}{
      font-size:var(--large-text);
    }

    font-family: var(--sans);
    font-weight:400;
    max-width:30em;
  }
`

export default function IntroLetter ({ data }) {
  return (
    <FacultyLetter>
      <PortableText blocks={data._rawLetter} />
    </FacultyLetter>

  )
}
